// extracted by mini-css-extract-plugin
module.exports = {"backButton":"BackButton_backButton__18SxD","arrowBackIcon":"BackButton_arrowBackIcon__2dpMm","materialGroup":"BackButton_materialGroup__2Oyxn","action":"BackButton_action__1-6Dq"};